import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import ButtonMUI, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { CircularProgress } from '@mui/material';
import { SystemCssProperties } from '@mui/system';


type ButtonCssProps = 'height' | 'width' | 'minWidth' | 'm' | 'mt' | 'mr' | 'mb' | 'ml' | 'p' | 'pt' | 'pr' | 'pb' | 'pl';
interface ButtonCssProperty extends Pick<SystemCssProperties, ButtonCssProps> { }

export interface IButton
    extends LoadingButtonProps,
    Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'>,
    ButtonCssProperty {
    variant?: 'primary' | 'accent' | 'secondary' | 'stroke' | 'text';
    title?: string;
    size?: LoadingButtonProps['size'];
    shape?: 'default' | 'circle';
    fontSize?: string | number;
    lineHeight?: string | number;
}

export const Button = forwardRef<HTMLButtonElement, IButton>(
    (
        {
            variant = 'primary',
            children,
            title,
            size = 'large',
            shape = 'default',
            width,
            minWidth,
            height,
            m,
            mt,
            mr,
            mb,
            ml,
            p,
            pt,
            pr,
            pb,
            pl,
            sx,
            fontSize,
            lineHeight,
            ...props
        },
        ref,
    ) => (
        <ButtonMUI
            ref={ref}
            sx={{
                ...shape === 'circle' && {
                    padding: size === 'large' || size === 'medium' ? 2.5 : 1,
                    width: ({ spacing }) => size === 'large'
                        ? spacing(14)
                        : size === 'medium'
                            ? spacing(12)
                            : spacing(8),
                    borderRadius: size === 'large' || size === 'medium'
                        ? 6
                        : 4,
                },
                ...{
                    width,
                    minWidth,
                    height,
                    m,
                    mt,
                    mr,
                    mb,
                    ml,
                    p,
                    pt,
                    pr,
                    pb,
                    pl,
                    fontSize,
                    lineHeight,
                },
                ...sx,
            }}
            size={size}
            variant={variant}
            loadingIndicator={
                <CircularProgress color='inherit' size={size === 'large' ? '20px' : '13.33px'} />
            }
            {...props}
        >
            {title || children}
        </ButtonMUI>
    ),
);
